const settingsPage = {
  "settings.save.success": "Configuración guardada.",
  "settings.save.error": "No se pudo guardar la configuración. Inténtalo de nuevo.",
  'settings.page.title': 'Configuración',
  'settings.page.section.profile': 'Perfil',
  'settings.page.link.my-profile': 'Mi Perfil',
  'settings.page.link.switch-profile': 'Cambiar Perfil',
  'settings.page.link.members': 'Miembros',
  'settings.page.section.account': 'Cuenta',
  'settings.page.section.general': 'General',
  'settings.page.section.admin': 'Admin',
  'settings.page.link.switch-account': 'Cambiar Cuenta',
  'settings.page.link.privacy': 'Privacidad',
  'settings.page.link.security': 'Seguridad',
  'settings.page.link.help-and-support': 'Ayuda y suporte',
  'settings.page.link.about': 'Acerca de',
  'settings.page.link.super-admin': 'Super Admin',
  'settings.page.link.dev-settings': 'Dev Settings',
  'settings.page.section.system': 'Sistema',
  'settings.page.link.display-and-graphics': 'Pantalla y Gráficos',
  'settings.page.link.audio': 'Audio',
  'settings.page.link.in-game-feedback': 'Comentario en Juego',
  'settings.page.link.controller': 'Controles',
  'settings.page.link.my-kit': 'Mi Equipación',
  'settings.page.link.default-kit': 'Equipación de la cuenta',
};

const membersPage = {
  "settings.members.title": "Miembros",
  "settings.members.section.profiles": "{{ count }} perfiles ({{ available }} disponibles)",
  "settings.members.you": "Tú",
  "settings.members.selected": "{{ count }} perfiles seleccionados",
  "settings.members.assign-role": "Asignar Rol",
  "settings.members.delete": "Eliminar",
  "settings.members.profiles-remaining": "{{ count }} Restantes",
  "settings.members.filter.members": "Miembros",
  "settings.members.filter.invites": "Invitaciones",
  "settings.members.assign-role.title": "Asignar Rol",
  "settings.members.assign-role.description": "Ajusta el rol de los usuarios seleccionados.",
  "settings.members.assign-role.cancel": "Cancelar",
  "settings.members.assign-role.save": "Guardar",
  "settings.members.delete.title": "¿Eliminar miembros?",
  "settings.members.delete.description": "Esta acción no se puede deshacer. Los usuarios serán eliminados permanentemente de tu cuenta.",
  "settings.member.delete.title": "¿Eliminar miembro?",
  "settings.member.delete.description": "Esta acción no se puede deshacer. El usuario será eliminado permanentemente de tu cuenta.",
  "settings.members.profile-limit": "Tu cuenta ha alcanzado el límite de perfiles. Para invitar más miembros, actualiza tu suscripción.",
  "settings.members.pending-invites.title": "Invitaciones Pendientes",
  "settings.members.pending-invites.description": "Has sido invitado a unirte a las siguientes cuentas. Acepta una invitación para obtener acceso a la cuenta.",
  "settings.members.pending-invites.accept": "Aceptar",
  "settings.members.pending-invites.decline": "Rechazar",
  "settings.members.invited-by": "Invitado por {{ name }}",
  "settings.members.invite.edit.title": "Gestionar Invitación Pendiente",
  "settings.members.invite.edit.description": "Invitación pendiente para {{ email }}",
  "settings.members.invite.edit.description.existing": "Invitación pendiente para usuario {{ email }}",
  "settings.members.invite.edit.recipient": "Destinatario: {{ name }}",
  "settings.members.invite.resend": "Reenviar Invitación",
  "settings.members.invite.delete": "Eliminar Invitación",
  "settings.members.pending": "Invitación Pendiente",
  "settings.members.add-member": "Añadir Miembro",
  "settings.members.invite-member": "Invitar Usuario",
  "settings.members.invite-member.count": "Invitar Usuario ({{ count }} restantes)",
};

const editMemberPage = {
  "settings.edit-member.title": "Editar Miembro",
  "settings.edit-member.details.title": "Detalles",
  "settings.edit-member.details.first": "Nombre",
  "settings.edit-member.details.last": "Apellido",
  "settings.edit-member.details.phone": "Número de Teléfono",
  "settings.edit-member.details.gender": "Género",
  "settings.edit-member.details.role": "Rol",
  "settings.edit-member.preferences.title": "Preferencias",
  "settings.edit-member.preferences.join-leaderboards": "Unirse a Clasificaciones",
  "settings.edit-member.preferences.anonymous-ranking": "Clasificación Anónima",
  "settings.edit-member.notifications.title": "Notificaciones",
};

const profilePage = {
  "settings.profile.title": "Perfil",
  "settings.profile.title.alt":  "Editar Miembro",
  "settings.profile.details": "Detalles",
  "settings.profile.details.first": "Nombre",
  "settings.profile.details.last": "Apellido",
  "settings.profile.details.phone": "Teléfono",
  "settings.profile.details.gender": "Género",
  "settings.profile.details.role": "Rol",
  "settings.profile.details.account-owner-warning": "El propietario de la cuenta no se puede cambiar aquí.",
  "settings.profile.preferences": "Preferencias",
  "settings.profile.preferences.join-leaderboards": "Unirse a Clasificaciones",
  "settings.profile.preferences.anonymous-ranking": "Clasificación Anónima",
  "settings.profile.notifications": "Notificaciones"
};


const myKitPage = {
  "settings.my-kit.title": "Mi Equipación",
  "settings.my-kit.section": "Personaliza tu equipación",
  "settings.my-kit.not-admin-warning": "Solo los administradores roles o superiores pueden personalizar la equipación de la cuenta.",
};

const defaultKitPage = {
  "settings.default-kit.title": "Equipación de la cuenta",
  "settings.default-kit.section": "Personaliza tu equipación predeterminada",
};

const audioPage = {
  "settings.audio.title": "Audio",
  "settings.audio.section": "Nivel de Volumen",
  "settings.audio.master": "Master",
  "settings.audio.music": "Música",
  "settings.audio.voice": "Voz",
  "settings.audio.crowd": "Estadio",
};

const feedbackPage = {
  "settings.feedback.title": "Comentario en Juego",
  "settings.feedback.section.text": "Mostrar Retroalimentación en Texto",
  "settings.feedback.section.voice": "Dar Retroalimentación por Voz",
  "settings.feedback.text.critical": "Scaneos Críticos",
  "settings.feedback.text.decisions": "Decisiones",
  "settings.feedback.voice.scan-rate": "Frecuencia",
  "settings.feedback.voice.scan-timing": "Ritmo",
  "settings.feedback.voice.critical": "Scaneos Críticos",
  "settings.feedback.voice.awareness": "Memoria",
  "settings.feedback.voice.decisions": "Decisiones",
};

const controllerPage = {
  "settings.controller.title": "Controles",
  "settings.controller.section": "Vibración del Controlador",
  "settings.controller.haptic.strength": "Intensidad de Vibración",
};

const languageSettingsPage = {
  "settings.language.title": "Configuración de Idioma",
  "settings.language.section": "Preferencias de Idioma",
  "settings.language.select": "Seleccionar Idioma",
  "settings.page.link.language": "Idioma",
};

export const settings = {
  ...settingsPage,
  ...membersPage,
  ...editMemberPage,
  ...profilePage,
  ...audioPage,
  ...myKitPage,
  ...defaultKitPage,
  ...feedbackPage,
  ...controllerPage,
  ...languageSettingsPage,
};
